/* frontend/src/pages/LessorList.js */
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Plus, Edit, Eye } from 'lucide-react';
import api from '../api';
import { ShadcnDataTable } from '../components/ShadcnDataTable';
import { Button } from '../components/ui/button';
import { PageHeader } from '../components/common';

export default function LessorList() {
  const { t } = useTranslation();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    loadLessors();
  }, []);

  const loadLessors = async () => {
    try {
      const response = await api.get('/locadoras');
      setData(response.data);
    } catch (error) {
      console.error('Error loading lessors:', error);
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    { 
      field: 'nomeFantasia', 
      headerName: t('lessor.list.columns.name'), 
      flex: 1,
      renderCell: (row) => row.nomeFantasia || '-'
    },
    { 
      field: 'email', 
      headerName: t('lessor.list.columns.email'), 
      flex: 1,
      renderCell: (row) => row.contatoPrincipal?.email || '-'
    },
    { 
      field: 'telefone', 
      headerName: t('lessor.list.columns.phone'), 
      flex: 1,
      renderCell: (row) => row.contatoPrincipal?.telefone || row.contatoPrincipal?.celular || '-'
    },
    { 
      field: 'cidade', 
      headerName: t('lessor.list.columns.city'), 
      flex: 1,
      renderCell: (row) => row.endereco?.cidade || '-'
    },
    { 
      field: 'estado', 
      headerName: t('lessor.list.columns.state'), 
      width: 100,
      renderCell: (row) => row.endereco?.estado || '-'
    },
    { 
      field: 'active',
      headerName: t('lessor.list.columns.status'),
      width: 120,
      renderCell: (row) => (
        <span className="px-2 py-1 text-xs rounded-[4px] bg-green-100 text-green-800">
          {t('lessor.list.status.active')}
        </span>
      )
    }
  ];

  const actions = [
    {
      icon: <Eye className="h-4 w-4" />,
      label: t('lessor.list.actions.view'),
      onClick: (row) => navigate(`/admin/locadoras/${row._id}`),
      className: 'text-gray-600 hover:text-primary'
    },
    {
      icon: <Edit className="h-4 w-4" />,
      label: t('lessor.list.actions.edit'),
      onClick: (row) => navigate(`/admin/locadoras/${row._id}/edit`),
      className: 'text-gray-600 hover:text-primary'
    }
  ];

  return (
    <div className="space-y-6">
      <PageHeader
        title={t('lessor.list.title')}
        description={t('lessor.list.description')}
      >
        <Button
          variant="default"
          onClick={() => navigate('/admin/locadoras/create')}
          className="flex items-center gap-1"
        >
          <Plus className="h-4 w-4" />
          {t('lessor.list.actions.newLessor')}
        </Button>
      </PageHeader>

      <div className="space-y-4">
        <ShadcnDataTable
          columns={columns}
          data={data}
          loading={loading}
          actions={actions}
          onRowClick={(row) => navigate(`/admin/locadoras/${row._id}`)}
        />
      </div>
    </div>
  );
}